/* ====== GPETS / Stape compatible tracking (sin begin_checkout) ====== */
(function () {
  window.dataLayer = window.dataLayer || [];

  // ---------- Utilidades ----------
  // ID único por evento (para dedupe Web/Server)
  window.__evtSeed = window.__evtSeed || (crypto?.randomUUID?.() || String(Date.now()));
  function nextEventId() { return window.__evtSeed + '-' + Date.now(); }

  const isProdPage = () => /\/products\/[^/?#]+/.test(location.pathname);

  const shopCurrency =
    document.documentElement.getAttribute('data-shop-currency') ||
    (window.Shopify && (Shopify.currency?.active || Shopify.theme?.currency)) ||
    'USD';

  function centsToNumber(c) { return Math.round(Number(c || 0)) / 100; }

  // ---------- Dedupe por ventana corta ----------
  // Evita repetir el MISMO evento con las mismas claves en pocos segundos.
  const fired = new Map(); // key -> timestamp
  function keyOf(ev, payload) {
    const items = payload?.ecommerce?.items || [];
    const first = items[0] || {};
    const itemKey = String(first.item_id || first.id || '');
    const qty = String(first.quantity || payload?.quantity || '');
    const val = String(payload?.ecommerce?.value ?? payload?.value ?? '');
    return `${ev}|${itemKey}|${qty}|${val}`;
  }
  function pushOnce(obj, ttlMs = 5000) {
    try {
      const k = keyOf(obj.event, obj);
      const now = Date.now();
      if (fired.has(k) && now - fired.get(k) < ttlMs) {
        console.info('[DL] skip duplicate', k);
        return;
      }
      fired.set(k, now);
      window.dataLayer.push(obj);
    } catch (_) {}
  }

  // ---------- Anti-doble para AddToCart (submit + fetch) ----------
  let lastATCSubmitTs = 0;
  function markATCSubmit() { lastATCSubmitTs = Date.now(); }
  function submitJustHappened() { return Date.now() - lastATCSubmitTs < 1500; }

  async function fetchProductByHandleFromURL() {
    const m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return null;
    try {
      const res = await fetch(`/products/${m[1]}.js`, { credentials: 'same-origin' });
      if (!res.ok) return null;
      return await res.json();
    } catch (_) { return null; }
  }

  // ---------- VIEW ITEM (solo PDP) ----------
  document.addEventListener('DOMContentLoaded', async function () {
    if (!isProdPage()) return;
    const p = await fetchProductByHandleFromURL();
    if (!p) return;
    const v = p.variants?.[0] || {};
    const price = centsToNumber(v.price || p.price);

    pushOnce({
      event: 'view_item_stape',
      event_id: nextEventId(),
      ecommerce: {
        currency: shopCurrency,
        value: price,
        items: [{
          item_id: String(v.id || p.id || ''),
          item_name: p.title || '',
          item_brand: p.vendor || '',
          item_variant: v.title || '',
          price: price,
          quantity: 1
        }]
      }
    });
  });

  // ---------- ADD TO CART ----------
  // a) Formularios /cart/add (HTML submit)
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;

    try {
      markATCSubmit(); // marca para ignorar fetch inmediato duplicado
      const fd = new FormData(form);
      const vid = fd.get('id');
      const qty = Number(fd.get('quantity') || 1);

      const p = await fetchProductByHandleFromURL();
      const v = (p?.variants || []).find(x => String(x.id) === String(vid)) || p?.variants?.[0] || {};
      const price = centsToNumber(v.price || p?.price);

      pushOnce({
        event: 'add_to_cart_stape',
        event_id: nextEventId(),
        ecommerce: {
          currency: shopCurrency,
          value: price * qty,
          items: [{
            item_id: String(v.id || p?.id || ''),
            item_name: p?.title || '',
            item_brand: p?.vendor || '',
            item_variant: v.title || '',
            price: price,
            quantity: qty
          }]
        }
      });
    } catch (_) {}
  });

  // b) Intercepta fetch a /cart/add(.js) (AJAX)
  const _fetch = window.fetch;
  window.fetch = async function (input, init) {
    try {
      const url = typeof input === 'string' ? input : (input?.url || '');
      const method = (init?.method || 'GET').toUpperCase();
      const isAdd = /\/cart\/add(\.js|\.json)?(\?|$)/.test(url) && (method === 'POST' || method === 'GET');

      if (isAdd) {
        // si justo antes hubo submit, evita duplicar
        if (submitJustHappened()) {
          return _fetch.apply(this, arguments);
        }

        let vid = null, qty = 1;
        if (init?.body instanceof FormData) {
          vid = init.body.get('id'); qty = Number(init.body.get('quantity') || 1);
        } else if (typeof init?.body === 'string') {
          const sp = new URLSearchParams(init.body); vid = sp.get('id'); qty = Number(sp.get('quantity') || 1);
        } else {
          try {
            const u = new URL(url, location.origin);
            vid = u.searchParams.get('id'); qty = Number(u.searchParams.get('quantity') || 1);
          } catch (_) {}
        }

        const p = await fetchProductByHandleFromURL();
        const v = (p?.variants || []).find(x => String(x.id) === String(vid)) || p?.variants?.[0] || {};
        const price = centsToNumber(v.price || p?.price);

        pushOnce({
          event: 'add_to_cart_stape',
          event_id: nextEventId(),
          ecommerce: {
            currency: shopCurrency,
            value: price * qty,
            items: [{
              item_id: String(v.id || p?.id || ''),
              item_name: p?.title || '',
              item_brand: p?.vendor || '',
              item_variant: v.title || '',
              price: price,
              quantity: qty
            }]
          }
        });
      }
    } catch (_) {}
    return _fetch.apply(this, arguments);
  };

  // (Sin begin_checkout: lo maneja el pixel/servidor en checkout)
})();
